import Typography from "@material-ui/core/Typography";
import React from "react";
import Theme from "../../utils/Theme";

interface TypographyTitleBiggerProps {
    text: string;
    className?: string;
    marginLeft?: any;
}

export default class TypographyTitleBigger extends React.Component<TypographyTitleBiggerProps> {
    render() {
        return (
            <Typography
                className={this.props.className}
                variant="h2"
                style={{
                    marginLeft: this.props.marginLeft,
                    marginBottom: Theme.smallSpacing,
                    color: Theme.primaryTextColour
                }}
            >
                {this.props.text}
            </Typography>
        );
    }
}